import React, { useEffect, useState } from "react";

import NeatAgent from "./NeatAgent";
import { evolve } from "../../neat/evolve";
import InnovationDB from "../../neat/innovatinoDB";
import Network from "../../neat/network";
import params from "./parameters.json";

import CatchAsteroid from "./CatchAsteroid";
import { GameProps } from "../util";

function initialPlayerRect(options: GameOptions) {
  return {
    x: 200,
    y: 400,
    width: options.playerWidth,
    height: 10,
  };
}

interface GameOptions {
  agentsNum: number;
  playerSpeed: number;
  asteroidSpeed: number;
  playerWidth: number;
}

const Game = ({
  options,
  onInit,
  onEachGeneration,
}: GameProps<GameOptions>) => {
  const [generation, setGeneration] = useState(1);
  const [agents, setAgents] = useState<NeatAgent[]>([]);

  const [pool, setPool] = useState<Network[]>([]);
  const [innovDB] = useState(new InnovationDB());

  const onExtinct = () => {
    setGeneration(generation + 1);

    pool.sort((a, b) => b.getFitness() - a.getFitness());

    const [newPool, species] = evolve(pool, params, innovDB);
    onEachGeneration(pool, species);
    setPool(newPool);

    const newAgents = [];
    for (const network of newPool) {
      newAgents.push(new NeatAgent(initialPlayerRect(options), network));
    }

    setAgents(newAgents);
  };

  useEffect(() => {
    onInit();
    const initPool = [],
      initAgents = [];
    for (let i = 0; i < options.agentsNum; i++) {
      const network = new Network(3, 3, innovDB);
      initPool.push(network);
      initAgents.push(new NeatAgent(initialPlayerRect(options), network));
    }

    setPool(initPool);
    setAgents(initAgents);
  }, [options, innovDB, onInit]);

  return (
    <CatchAsteroid
      agents={agents}
      onExtinct={onExtinct}
      playerSpeed={options.playerSpeed}
      asteroidSpeed={options.asteroidSpeed}
    />
  );
};

export default Game;
